"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorBoundary = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var react_2 = require("@heroui/react");
var ErrorBoundary = /** @class */ (function (_super) {
    __extends(ErrorBoundary, _super);
    function ErrorBoundary(props) {
        var _this = _super.call(this, props) || this;
        _this.handleReset = function () {
            _this.setState({ hasError: false, error: null });
        };
        _this.state = { hasError: false, error: null };
        return _this;
    }
    ErrorBoundary.getDerivedStateFromError = function (error) {
        return { hasError: true, error: error };
    };
    ErrorBoundary.prototype.componentDidCatch = function (error, errorInfo) {
        // Log error to console in development
        if (process.env.NODE_ENV === "development") {
            console.error("ErrorBoundary caught an error:", error, errorInfo);
        }
        // Call optional error handler
        if (this.props.onError) {
            this.props.onError(error, errorInfo);
        }
        // In production, you might want to log to an error reporting service
        // e.g., Sentry, LogRocket, etc.
    };
    ErrorBoundary.prototype.render = function () {
        if (this.state.hasError) {
            if (this.props.fallback) {
                return this.props.fallback;
            }
            return ((0, jsx_runtime_1.jsx)("div", { className: "flex min-h-screen items-center justify-center p-4", children: (0, jsx_runtime_1.jsx)(react_2.Card, { className: "max-w-md border border-danger", children: (0, jsx_runtime_1.jsx)(react_2.CardBody, { className: "p-6", children: (0, jsx_runtime_1.jsxs)("div", { className: "space-y-4", children: [(0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("h2", { className: "text-lg font-semibold text-danger", children: "Something went wrong" }), (0, jsx_runtime_1.jsx)("p", { className: "mt-2 text-sm text-default-500", children: "An unexpected error occurred. Please try refreshing the page." }), process.env.NODE_ENV === "development" && this.state.error && ((0, jsx_runtime_1.jsxs)("details", { className: "mt-4", children: [(0, jsx_runtime_1.jsx)("summary", { className: "cursor-pointer text-xs text-default-400", children: "Error details" }), (0, jsx_runtime_1.jsxs)("pre", { className: "mt-2 overflow-auto rounded bg-default-100 p-2 text-xs", children: [this.state.error.toString(), this.state.error.stack && "\n".concat(this.state.error.stack)] })] }))] }), (0, jsx_runtime_1.jsxs)("div", { className: "flex gap-3", children: [(0, jsx_runtime_1.jsx)(react_2.Button, { color: "primary", variant: "flat", onPress: this.handleReset, className: "flex-1", children: "Try Again" }), (0, jsx_runtime_1.jsx)(react_2.Button, { color: "primary", onPress: function () { return window.location.reload(); }, className: "flex-1", children: "Refresh Page" })] })] }) }) }) }));
        }
        return this.props.children;
    };
    return ErrorBoundary;
}(react_1.Component));
exports.ErrorBoundary = ErrorBoundary;
